import script from "./esAddCommonFinancialGroupForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esAddCommonFinancialGroupForm.vue?vue&type=script&setup=true&lang=ts"

import "./esAddCommonFinancialGroupForm.vue?vue&type=style&index=0&id=5be0ac4d&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be0ac4d"]])

export default __exports__